import { IconButton, Box } from '@mui/material';
import { Close } from '@mui/icons-material';
import { styled } from '@mui/system';

const StyledModal = styled('div')(({ theme }) => ({
  position: 'fixed',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  zIndex: 1000,
  backgroundColor: theme.opacities.lightOverlay,
  backdropFilter: 'blur(10px)',
  color: theme.palette.text.primary,
  boxShadow: theme.customShadows.shadowColor,
}));

const StyledModalOverlay = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
}));

const StyledModalContent = styled(Box)(({ theme }) => ({
  backgroundColor: theme.custom.surfaceElevated,
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  padding: 'clamp(16px, 4vw, 28px)',
  borderRadius: '24px',
  width: 'calc(100% - 24px)',
  maxWidth: '620px',
  maxHeight: 'calc(100vh - 32px)',
  border: `1px solid ${theme.custom.border}`,
  boxShadow: '0 30px 90px rgba(0, 0, 0, .30)',
  zIndex: 1001,
}));

const ModalTitle = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  position: 'relative',
  textAlign: 'center',
}));

const ModalContent = styled(Box)(({ theme }) => ({
  borderRadius: '18px',
  maxWidth: '100%',
  maxHeight: 'calc(100vh - 130px)',
  margin: '0 auto',
  width: '100%',
  height: 'auto',
  overflowY: 'auto',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  boxSizing: 'border-box',
}));

function Modal({ isOpen, onClose, title, children, maxWidth = '620px' }) {
  if (!isOpen) return null;

  // Adjust font size dynamically based on the length of the title
  const fontSize =
    title.length > 7
      ? {
          xs: '1rem', 
          sm: '1.25rem', 
          md: '1.5rem',
          lg: '1.75rem',
        }
      : {
          xs: '1.25rem', 
          sm: '1.5rem',
          md: '1.75rem',
          lg: '2rem',
        };

  return (
    <StyledModal>
      <StyledModalOverlay onClick={onClose}>
        <StyledModalContent
          onClick={(e) => e.stopPropagation()}
          sx={{ maxWidth }}
        >
          <ModalTitle
            sx={{
              fontFamily: 'Chainz',
              fontWeight: 'normal',
              fontSize: fontSize, // Dynamic font size
              wordBreak: 'break-word',
              textShadow: 'none',
              paddingBottom: '14px',
              borderBottom: (theme) => `1px solid ${theme.custom.border}`,
            }}
          >
            <h2 style={{ margin: 0 }}>{title}</h2>
            <IconButton
              edge="end"
              color="inherit"
              onClick={onClose}
              aria-label={`Close ${title}`}
              sx={(theme) => ({
                position: 'absolute',
                right: 0,
                bgcolor: theme.palette.action.hover,
              })}
            >
              <Close />
            </IconButton>
          </ModalTitle>
          <ModalContent>{children}</ModalContent>
        </StyledModalContent>
      </StyledModalOverlay>
    </StyledModal>
  );
}

export default Modal;
